import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import ResultNavbar from "../components/ResultNavbar";
import ResultTable from "../components/ResultTable";
const Result = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };
  return (
    <div>
      <Sidebar debarStateChange={handleSidebarStateChange} />
      <ResultNavbar />
      <ResultTable />
    </div>
  );
};

export default Result;
